import * as React from "react";
import { Flex, Box } from "@quandoo-dev/cookbook/lib/layout";
import { Body } from "@quandoo-dev/cookbook/lib/typography";
import Img, { GatsbyImageProps } from "gatsby-image";
import useTranslations from "../../hooks/useTranslations";
import Link from "../../components/link";

interface MetaInfoProps {
  author: any;
  publishDate: string;
  timeToRead?: number;
  staticImage: any;
  country: string;
}

const MetaInfo: React.FC<MetaInfoProps> = ({
  author,
  timeToRead,
  publishDate,
  staticImage,
  country,
}) => {
  const [postedByText, minReadText] = useTranslations(country,[
    "post.posted_by",
    "post.min_read",
  ]);

  const image = staticImage === null ? 
  <Img
    fixed={author.profileImage.fixed}
    style={{
      borderRadius: "50%",
      verticalAlign: "top"
    }}
  />
  : <img src={staticImage} style={{
    borderRadius: "50%",
    verticalAlign: "top",
    width: "40px"
  }} />

  return (
    <Flex>
      <Link to={`/author/${author.slug}`}>
        {image}
        <Box ml="xs" style={{display: "inline-block"}}>
          <Body size="xs" color="secondary">
            {postedByText} {author.firstName} {author.lastName}
          </Body>
          <Body size="xs" color="secondary">
            {publishDate} &#183; {timeToRead} {minReadText}
          </Body>
        </Box>
      </Link>
    </Flex>
  );
};

export default MetaInfo;
